import React from "react";
import PropTypes from "prop-types";

function ModalConfirmation({
  modal_id,
  title,
  message,
  question,
  onAccept,
  onCancel,
}) {
  let questionLabel;
  let messageLabel;

  if(question) {
      questionLabel = (
          <h5 dangerouslySetInnerHTML={{__html: question }} />
      )
  }

  if (message) {
    messageLabel = (
      <p>
        <mark dangerouslySetInnerHTML={{ __html: message }} />
      </p>
    );
  }
  return (
    <div className="modal fade" id={modal_id} role="dialog" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="alert alert-secondary">
              {questionLabel}
              {messageLabel}
            </div>
          </div>
          <div className="modal-footer">
            <div className="flex-2-separated">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => {
                  onAccept();
                }}
              >
                Aceptar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={() => {
                  if (onCancel) onCancel();
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ModalConfirmation.propTypes = {
  modal_id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  question: PropTypes.string,
  message: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

ModalConfirmation.defaultProps = {
  title: "Confirmaci&oacute;n",
  message: "",
};

export default ModalConfirmation;
